import styled from "styled-components";

import { ApiCategory } from "../types";

type CategorySelectorProps = {
  categories: ApiCategory[];
  selectedCategories: ApiCategory[];
  onChange: (categories: ApiCategory[]) => void;
};

const Pill = styled.div<{ active?: boolean }>`
  display: flex;
  padding: 4px 12px;
  border: 1px solid #e1e5e9;
  color: #010024;
  border-radius: 100px;
  white-space: nowrap;
  font-size: 12px;
  font-weight: bold;

  ${({ active }) =>
    active &&
    `
    background-color: #0d6efd;
    color: white;
    border-color: #0d6efd;
  `}
`;

const Pills = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 4px;
  padding: 10px 0;
`;

export default function CategorySelector({
  categories,
  selectedCategories,
  onChange,
}: CategorySelectorProps) {
  return (
    <Pills>
      {categories.map((category) => (
        <Pill
          active={selectedCategories.includes(category)}
          key={category.uuid}
          onClick={() => {
            const newSelection = selectedCategories.includes(category)
              ? selectedCategories.filter((c) => c !== category)
              : [...selectedCategories, category];
            onChange(newSelection);
          }}
        >
          {category.name}
        </Pill>
      ))}
    </Pills>
  );
}
